import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, Producto, SearchProductoRequest, SearchProductoResponse, SaveProductoDto } from "../model/index";
import { SharedFunctions } from 'src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class ProductoService extends CrudService<Producto, number, SaveProductoDto, SearchProductoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'producto', sharedFunctions);

  }

  getAnonymous(encryptedId: string): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/GetList/'+encryptedId, this.httpOptions);
  }
}